import { animateAttribute, genericElementToFormData, onDelegatedClick, setCss, setLoading, splitAlertTitleText, swalAlert } from '../functions.js';

export default class BigpackElement extends HTMLElement {

    #select = null;
    #saveButton = null;

    connectedCallback() {
        this.#select = this.querySelector('select[name=slot_id]');
        this.#saveButton = this.querySelector('.js-save');

        onDelegatedClick(this, '.js-cancel', this.#onCancelClick.bind(this));
        onDelegatedClick(this, '.js-save', this.#onSaveClick.bind(this));

        this.#select.addEventListener('change', () => {
            this.#saveButton.disabled = false;
        });
    }

    #onCancelClick() {
        document.body.classList.add('prevent-scroll');

        let text = window.TEXTS.__POPUP_CANCEL_BOOKING_CONFIRM__.replace('{0}', this.dataset.cancelRefundDate);

        let parts = splitAlertTitleText(text);

        return Swal.fire({
            title: parts.title,
            text: parts.text,
            confirmButtonText: window.TEXTS.YES,
            cancelButtonText: window.TEXTS.NO,
            showCancelButton: true,
            focusConfirm: false,
            buttonsStyling: false,
            showCloseButton: true,
            customClass: {
                confirmButton: 'button1',
                cancelButton: 'button1 button1--gray',
                // popup: 'text-center',
            }
        }).then(result => {

            if (result.isConfirmed) {
                let data = genericElementToFormData(this);
                setLoading(this, true);
                fetch(this.getAttribute('data-cancel-url'), {
                    method: 'POST',
                    body: data
                }).then(res => res.json()).then(res => {
                    setLoading(this, false);
                    if (res.result === 1) {
                        this.#showConfirmation(res.msg).then(() => {
                            window.location.reload();
                        });
                    } else {
                        swalAlert(res.msg);
                    }
                }).catch(err => {
                    setLoading(this, false);
                    console.log(err);
                    swalAlert(err);
                });
            } else {
                document.body.classList.remove('prevent-scroll');
            }
            
            document.body.classList.remove('prevent-scroll');
            return result;
        });
    }

    #onSaveClick() {

        let data = genericElementToFormData(this);

        setLoading(this, true);
        fetch(this.getAttribute('data-save-url'), {
            method: 'POST',
            body: data
        }).then(res => res.json()).then(res => {
            setLoading(this, false);

            if (res.result === 1) {
                swalAlert(window.TEXTS.__SUCCESSFULLY_MODIFIED_BOOKING__);
            } else {
                swalAlert(res.msg);
            }
        }).catch(err => {
            setLoading(this, false);
            swalAlert(err);
        });
    }

    #showConfirmation(msg) {

        let parts = splitAlertTitleText(msg);

        return Swal.fire({
            title: parts.title,
            html: parts.text,
            showConfirmButton: false,
            buttonsStyling: false,
            showCloseButton: true,
            customClass: {
                confirmButton: 'button1',
                // popup: 'text-center',
            }
        });
    }
};

window.customElements.define('bigpack-element', BigpackElement);

